import { NgModule } from '@angular/core';
import { MatButtonModule, MatDialogModule, MatIconModule } from '@angular/material';
import { RouterModule, Routes } from '@angular/router';
import { LayoutModule, SharedModule } from '@app/shared';
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards';
import { BranchAddEditComponent } from './add-edit-list/branch-add-edit.component';
import { BranchListComponent } from './add-edit-list/branch-list.component';

const routes: Routes = [
  { path: '', component: BranchListComponent, canActivate: [AuthGuard], data: { title: 'Branch' } }
];
@NgModule({
  declarations: [BranchListComponent, BranchAddEditComponent],
  imports: [
    RouterModule.forChild(routes),
    LayoutModule,
    MatIconModule, MatButtonModule, MatDialogModule,
    SharedModule
  ],
  entryComponents: [BranchAddEditComponent]
})
export class BranchModule { }
